import React, { useState, useEffect } from 'react';
import Notification from './Notification';
import './Notification.css';

let notificationListener = null;

export const NotificationContainer = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    notificationListener = (notification) => {
      setNotifications(prev => [...prev, notification]);
    };

    return () => {
      notificationListener = null;
    };
  }, []);

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  };

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          notification={notification}
          onClose={removeNotification}
        />
      ))}
    </div>
  );
};

// Service de notifications
let notificationId = 0;

export const notify = {
  success: (message, title = null, duration = 4000) => {
    showNotification('success', message, title, duration);
  },
  error: (message, title = null, duration = 5000) => {
    showNotification('error', message, title, duration);
  },
  warning: (message, title = null, duration = 4500) => {
    showNotification('warning', message, title, duration);
  },
  info: (message, title = null, duration = 4000) => {
    showNotification('info', message, title, duration);
  }
};

function showNotification(type, message, title, duration) {
  if (notificationListener) {
    const notification = {
      id: notificationId++,
      type,
      message,
      title,
      duration
    };
    notificationListener(notification);
  }
}

export default NotificationContainer;
